import { useState } from "react";

import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";

import Button from "@/admin/atoms/Button";
import styles from "./LandingPageNavArea.module.css";
import Backdrop from "../../Backdrop";

export type LandingPageNavAreaProps = {
  showDesktopMenu: boolean;
};

function LandingPageNavArea(props: LandingPageNavAreaProps): JSX.Element {
  const { showDesktopMenu } = props;

  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [rotateClose, setRotateClose] = useState("rotate-0");
  const [frameHeigth, setFrameHeight] = useState("h-0");

  const closeSidebar = () => {
    setOpen?.(!open);
  };

  const NavItems = [
    {
      itemName: "How-To Guides",
      targetPage: "/admin-portal/onboarding/knowledge-base",
    },
    {
      itemName: "About Us",
      targetPage: "/admin-portal/onboarding/about-us",
    },
    {
      itemName: "Contact Us",
      targetPage: "/admin-portal/onboarding/contact-us",
    },
  ];

  /*
  const getViewArea = () => {
    const element = document.getElementById("choose-a-planscreen");
    element?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  */

  return (
    <div className={styles.frame} id="landing-page-nav">
      {open && (
        <Backdrop>
          <div className={`${styles.mobileNavFrame} ${frameHeigth}`}>
            <div className={styles.logoArea}>
              <Link href="/">
                <a>
                  <Image
                    src="/logo-light.svg"
                    alt="MyEdVault"
                    width={166}
                    height={37}
                  />
                </a>
              </Link>
              <div className={styles.sidebar_header}>
                <div className="w-[25px] h-[25px]">
                  <Image
                    src="/icons/closeBtnNav.svg"
                    alt="close Btn"
                    width={16}
                    height={16}
                    onClick={() => {
                      setRotateClose("rotate-180");
                      closeSidebar();
                    }}
                    className={`cursor-pointer ${rotateClose}`}
                  />
                </div>
              </div>
            </div>

            <div className={styles.mobileNavItemsArea}>
              {NavItems.length > 0
                ? NavItems.map((items) => (
                    <div className="w-full flex justify-between">
                      <Link href={items.targetPage}>
                        <a>
                          <span className="whitespace-nowrap">
                            {items.itemName}
                          </span>
                        </a>
                      </Link>
                      <Image
                        src="/icons/arrow-up.svg"
                        alt="close Btn"
                        width={16}
                        height={16}
                        onClick={closeSidebar}
                        className="cursor-pointer rotate-90"
                      />
                    </div>
                  ))
                : null}
            </div>

            <div className={styles.mobileButtonArea}>
              <Button
                variant="landing-secondary2"
                onClick={() => {
                  closeSidebar();
                  router.push("/admin-portal/onboarding/sign-in");
                }}
              >
                <p className="w-full  py-4">Sign in</p>
              </Button>

              <Button
                variant="landing-primary2"
                onClick={() => {
                  // getViewArea();
                  closeSidebar();
                  router.push("/sign-up");
                }}
              >
                <p className="w-full  py-4">Sign up</p>
              </Button>
            </div>
          </div>
        </Backdrop>
      )}
      <div className={styles.logoArea}>
        <Link href="/">
          <a>
            <Image
              src="/logo-light.svg"
              alt="MyEdVault"
              width={166}
              height={37}
            />
          </a>
        </Link>

        <div className={styles.sidebar_header}>
          <Image
            src="/icons/hamburgar.svg"
            alt="menu"
            width={25}
            height={25}
            onClick={() => {
              setFrameHeight("h-auto");
              closeSidebar();
            }}
            className="cursor-pointer"
          />
        </div>
      </div>
      {showDesktopMenu && (
        <div className={styles.middleArea}>
          {NavItems.length > 0
            ? NavItems.map((items) => (
                <div
                  className={`w-full ${
                    router.pathname.includes(items.targetPage)
                      ? "text-[#4856DD]"
                      : ""
                  }`}
                >
                  <Link href={items.targetPage}>
                    <a>
                      <span className="whitespace-nowrap">
                        {items.itemName}
                      </span>
                    </a>
                  </Link>
                </div>
              ))
            : null}
        </div>
      )}
      {showDesktopMenu && (
        <div className={styles.rightPane}>
          <Button
            variant="landing-secondary"
            onClick={() => {
              router.push("/admin-portal/onboarding/sign-in");
            }}
          >
            <p className="px-5 py-4">Sign in</p>
          </Button>

          <Button
            variant="landing-primary"
            onClick={() => {
              router.push("/sign-up");
            }}
          >
            <p className="px-5 py-4">Sign up</p>
          </Button>
        </div>
      )}
    </div>
  );
}

export default LandingPageNavArea;
